export default __webpack_public_path__ + "static/media/at.36eab260.svg";